import { NumberService } from '../shared/number.service';
import { Observable } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "../shared/number.service";
var epsilon = 0.001;
var zoomRate = 0.03;
var CameraService = /** @class */ (function () {
    function CameraService(numberService) {
        this.numberService = numberService;
        this.rotation = { vx: 0, vy: 0 };
        this.pan = { x: 0, y: 0, z: 0 };
        this.zoom = 0;
    }
    CameraService.prototype.getEye = function () {
        return Human.renderer.camera.eye;
    };
    CameraService.prototype.setEye = function (eye) {
        Human.renderer.camera.setLookAt({
            eye: eye
        });
    };
    CameraService.prototype.getCamera = function () {
        return Human.renderer.camera.getLookAt();
    };
    CameraService.prototype.setCamera = function (camera) {
        return Human.renderer.camera.setLookAt(camera);
    };
    CameraService.prototype.getCameraZoom = function () {
        return Human.renderer.camera.getZoom();
    };
    CameraService.prototype.captureCamera = function () {
        return {
            lookAt: Human.renderer.camera.getLookAt(),
            zoom: Human.renderer.camera.getZoom()
        };
    };
    CameraService.prototype.resetCamera = function () {
        return new Observable(function (observer) {
            Human.init.resetCamera(function () {
                observer.next();
                observer.complete();
            });
        });
    };
    CameraService.prototype.getDirection = function (hit) {
        var camera = this.getEye();
        var direction = vec3.create();
        direction[0] = camera.x - hit.worldPos[0];
        direction[1] = camera.y - hit.worldPos[1];
        direction[2] = camera.z - hit.worldPos[2];
        vec3.normalize(direction, direction);
        return direction;
    };
    CameraService.prototype.rotateCameraStatic = function (x, y) {
        Human.renderer.camera.rotateX(x);
        Human.renderer.camera.rotateY(y);
    };
    CameraService.prototype.panCameraStatic = function (x, y, z) {
        Human.renderer.camera.pan({ x: x, y: y, z: z });
    };
    CameraService.prototype.setHumanZoom = function (delta) {
        Human.renderer.camera.zoom(delta);
    };
    CameraService.prototype.setHumanZoomFactor = function (zoomFactor) {
        Human.renderer.camera.setZoom(zoomFactor);
    };
    CameraService.prototype.setCameraRotation = function (velocityX, velocityY) {
        this.rotation.vx = velocityY;
        this.rotation.vy = -velocityX;
    };
    CameraService.prototype.setCameraPan = function (velocityX, velocityY) {
        this.pan.x = velocityX;
        this.pan.y = velocityY;
    };
    CameraService.prototype.setCameraZoom = function (deltaY) {
        this.zoom = deltaY * zoomRate;
    };
    CameraService.prototype.tickCameraRotation = function () {
        this.rotation.vx = this.checkEpsilon(this.rotation.vx);
        this.rotation.vy = this.checkEpsilon(this.rotation.vy);
        return this.rotation;
    };
    CameraService.prototype.tickCameraPan = function () {
        this.pan.x = this.checkEpsilon(this.pan.x);
        this.pan.y = this.checkEpsilon(this.pan.y);
        this.pan.z = this.checkEpsilon(this.pan.z);
        return this.pan;
    };
    CameraService.prototype.tickCameraZoom = function () {
        this.zoom = this.checkEpsilon(this.zoom);
        return this.zoom;
    };
    /**
     * Returns if the cameras are equivalent.
     */
    CameraService.prototype.compareCameras = function (camera1, camera2) {
        return this.compareXYZ(camera1.eye, camera2.eye)
            && this.compareXYZ(camera1.look, camera2.look)
            && this.compareXYZ(camera1.up, camera2.up);
    };
    /**
     * Returns if the XYZ coordinates are equal.
     */
    CameraService.prototype.compareXYZ = function (model1, model2) {
        return model1.x === model2.x
            && model1.y === model2.y
            && model1.z === model2.z;
    };
    /**
     * Rounds the camera to the specified precision.
     */
    CameraService.prototype.roundCamera = function (camera, precision) {
        var eye = camera.eye, look = camera.look, up = camera.up;
        return {
            eye: this.numberService.roundModel(eye, precision),
            look: this.numberService.roundModel(look, precision),
            up: this.numberService.roundModel(up, precision)
        };
    };
    CameraService.prototype.checkEpsilon = function (value) {
        return (Math.abs(value) < epsilon) ? 0 : value;
    };
    CameraService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CameraService_Factory() { return new CameraService(i0.ɵɵinject(i1.NumberService)); }, token: CameraService, providedIn: "root" });
    return CameraService;
}());
export { CameraService };
